"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var tabletUtils_1 = require("./tabletUtils");
var TabletRenderer = (function () {
    function TabletRenderer(epigraphicUnits, locale, rendererType) {
        this.epigraphicUnits = [];
        this.epigraphicUnits = epigraphicUnits;
        this.epigraphicUnits.sort(function (a, b) { return a.objOnTablet - b.objOnTablet; });
        this.locale = locale;
        this.rendererType = rendererType;
        this.sortMarkupUnits();
        this.addLineNumbersToRegions();
    }
    TabletRenderer.prototype.getEpigraphicUnits = function () {
        return this.epigraphicUnits;
    };
    TabletRenderer.prototype.getLocale = function () {
        return this.locale;
    };
    TabletRenderer.prototype.getRendererType = function () {
        return this.rendererType;
    };
    TabletRenderer.prototype.sortMarkupUnits = function () {
        var damageTypes = ['damage', 'partialDamage', 'erasure'];
        this.epigraphicUnits = this.epigraphicUnits.map(function (unit) { return (__assign(__assign({}, unit), { markups: unit.markups.sort(function (a, b) {
                if (a.type === 'isSealImpression') {
                    return 1;
                }
                if (b.type === 'isSealImpression') {
                    return -1;
                }
                if (damageTypes.includes(a.type)) {
                    return 1;
                }
                if (damageTypes.includes(b.type)) {
                    return -1;
                }
                return 0;
            }) })); });
    };
    TabletRenderer.prototype.addLineNumbersToRegions = function () {
        this.epigraphicUnits = this.epigraphicUnits.reduce(function (newUnits, unit) {
            if (unit.epigType === 'region') {
                var objOnTablet_1 = unit.objOnTablet;
                var prevUnitIdx = lodash_1.default.findLastIndex(newUnits, function (backUnit) {
                    return backUnit.line !== null && backUnit.objOnTablet < objOnTablet_1;
                });
                var objLine = null;
                if (prevUnitIdx === -1) {
                    objLine = 0.1;
                }
                else if (newUnits[prevUnitIdx].line !== null) {
                    objLine = newUnits[prevUnitIdx].line + 0.1;
                }
                return __spreadArray(__spreadArray([], newUnits, true), [
                    __assign(__assign({}, unit), { line: objLine }),
                ], false);
            }
            return __spreadArray(__spreadArray([], newUnits, true), [unit], false);
        }, []);
    };
    TabletRenderer.prototype.tabletReading = function () {
        var _this = this;
        var tabletReading = this.sides
            .map(function (side) { return "".concat(side.side, "\n").concat(_this.sideReading(side.side)); })
            .join('\n')
            .trim();
        return (0, tabletUtils_1.localizeString)(tabletReading, this.locale);
    };
    Object.defineProperty(TabletRenderer.prototype, "sides", {
        get: function () {
            return this.epigraphicUnits.filter(function (unit) { return unit.epigType === 'section'; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabletRenderer.prototype, "lines", {
        get: function () {
            var orderedLines = this.epigraphicUnits
                .filter(function (unit) { return unit.line; })
                .map(function (unit) { return unit.line; });
            return Array.from(new Set(orderedLines));
        },
        enumerable: false,
        configurable: true
    });
    TabletRenderer.prototype.sideReading = function (side) {
        var _this = this;
        var lineReadings = [];
        var columns = this.columnsOnSide(side);
        columns.forEach(function (column) {
            _this.linesInColumn(column, side).forEach(function (lineNum) {
                lineReadings.push("".concat(_this.lineReading(lineNum)));
            });
        });
        var sideReading = lineReadings.join('\n');
        return (0, tabletUtils_1.localizeString)(sideReading, this.locale);
    };
    TabletRenderer.prototype.getRegionUnitByLine = function (lineNum) {
        if (this.isRegion(lineNum)) {
            var unitsOnLine = this.getUnitsOnLine(lineNum);
            return unitsOnLine[0];
        }
        return null;
    };
    TabletRenderer.prototype.isRegion = function (lineNum) {
        var unitsOnLine = this.getUnitsOnLine(lineNum);
        return unitsOnLine.length === 1 && unitsOnLine[0].epigType === 'region';
    };
    TabletRenderer.prototype.isRegionType = function (lineNum, type) {
        if (!this.isRegion(lineNum)) {
            return false;
        }
        var unitsOnLine = this.getUnitsOnLine(lineNum);
        return unitsOnLine[0].markups.some(function (unit) { return unit.type === type; });
    };
    TabletRenderer.prototype.isUndetermined = function (lineNum) {
        var unitsOnLine = this.getUnitsOnLine(lineNum);
        return (unitsOnLine.length === 1 &&
            unitsOnLine[0].epigType === 'undeterminedLines');
    };
    TabletRenderer.prototype.lineReading = function (lineNum) {
        var unitsOnLine = this.getUnitsOnLine(lineNum);
        if (this.isRegion(lineNum)) {
            return (0, tabletUtils_1.regionReading)(unitsOnLine[0]);
        }
        if (this.isUndetermined(lineNum)) {
            return (0, tabletUtils_1.undeterminedReading)(unitsOnLine[0]);
        }
        var charactersWithMarkup = this.addMarkupToEpigraphicUnits(unitsOnLine);
        var lineReading = (0, tabletUtils_1.convertMarkedUpUnitsToLineReading)(charactersWithMarkup, this.rendererType === 'regular');
        return (0, tabletUtils_1.localizeString)(lineReading, this.locale);
    };
    TabletRenderer.prototype.getLineWords = function (lineNum) {
        var _this = this;
        var unitsOnLine = this.getUnitsOnLine(lineNum).filter(function (unit) { return unit.epigType !== 'line'; });
        var charactersWithMarkup = this.addMarkupToEpigraphicUnits(unitsOnLine);
        var epigraphicWords = (0, tabletUtils_1.convertMarkedUpUnitsToEpigraphicWords)(charactersWithMarkup);
        return epigraphicWords.map(function (word) { return (__assign(__assign({}, word), { reading: word.reading ? (0, tabletUtils_1.localizeString)(word.reading, _this.locale) : null, signs: __spreadArray([], word.signs.map(function (sign) { return (__assign(__assign({}, sign), { reading: sign.reading
                    ? (0, tabletUtils_1.localizeString)(sign.reading, _this.locale)
                    : null })); }), true) })); });
    };
    TabletRenderer.prototype.getUnitsOnLine = function (lineNum) {
        return this.epigraphicUnits.filter(function (item) { return item.line === lineNum; });
    };
    TabletRenderer.prototype.columnsOnSide = function (side) {
        return this.epigraphicUnits
            .filter(function (unit) { return unit.epigType === 'column' && unit.side === side; })
            .map(function (unit) { return unit.column; });
    };
    TabletRenderer.prototype.linesInColumn = function (column, side) {
        var unitsInColumn = this.epigraphicUnits.filter(function (unit) { return unit.column === column && unit.side === side; });
        var lines = Array.from(new Set(unitsInColumn.filter(function (unit) { return unit.line; }).map(function (unit) { return unit.line; })));
        return lines;
    };
    TabletRenderer.prototype.addMarkupToEpigraphicUnits = function (epigUnits) {
        var _this = this;
        return epigUnits.map(function (unit) { return ({
            uuid: unit.uuid,
            type: unit.epigType === 'region' ? null : unit.type || 'phonogram',
            epigType: unit.epigType,
            reading: unit.epigType === 'region'
                ? unit.reading || ''
                : _this.markedUpEpigraphicReading(unit),
            discourseUuid: unit.discourseUuid,
            readingUuid: unit.readingUuid,
            signUuid: unit.signUuid,
            markups: unit.markups,
            spellingUuid: unit.spellingUuid,
            word: unit.word,
            form: unit.form,
            translation: unit.translation,
            parseInfo: unit.parseInfo,
            objOnTablet: unit.objOnTablet,
        }); });
    };
    TabletRenderer.prototype.markedUpEpigraphicReading = function (unit) {
        var _this = this;
        if (unit.markups) {
            var markedUpReading_1 = unit.reading;
            unit.markups.forEach(function (markup) {
                markedUpReading_1 = _this.applySingleMarkup(markup, markedUpReading_1 || '');
            });
            return markedUpReading_1 || '';
        }
        return unit.reading || '';
    };
    TabletRenderer.prototype.applySingleMarkup = function (markup, reading) {
        var formattedReading = reading;
        switch (markup.type) {
            case 'isCollatedReading':
                formattedReading += '!!';
                break;
            case 'isEmendedReading': {
                formattedReading += '!';
                break;
            }
            case 'uncertain': {
                formattedReading += '?';
                break;
            }
            case 'originalSign':
            case 'alternateSign':
                if (markup.altReading) {
                    formattedReading += "(".concat(markup.altReading, ")");
                }
                break;
            case 'undeterminedSigns':
                if (markup.value) {
                    if (markup.value > 0) {
                        formattedReading = 'x'.repeat(markup.value);
                    }
                    else if (markup.value === -1) {
                        formattedReading = '...';
                    }
                }
                break;
            case 'damage':
            case 'partialDamage':
            case 'superfluous':
            case 'omitted':
            case 'erasure':
            case 'isUninterpreted':
            case 'isWrittenOverErasure':
            case 'phoneticComplement':
            case 'isWrittenBelowTheLine':
            case 'isWrittenAboveTheLine':
                formattedReading = this.applyBracketMarkup(markup, reading);
                break;
            default:
                break;
        }
        return formattedReading;
    };
    TabletRenderer.prototype.getStartBracket = function (markupType) {
        switch (markupType) {
            case 'damage':
                return '[';
            case 'partialDamage':
                return '⸢';
            case 'superfluous':
                return '«';
            case 'omitted':
                return '‹';
            case 'erasure':
                return '{';
            case 'isUninterpreted':
                return ':';
            case 'isWrittenOverErasure':
                return '*';
            case 'phoneticComplement':
                return ';';
            case 'isWrittenBelowTheLine':
                return '/';
            case 'isWrittenAboveTheLine':
                return '\\';
            default:
                return '';
        }
    };
    TabletRenderer.prototype.getEndBracket = function (markupType) {
        switch (markupType) {
            case 'damage':
                return ']';
            case 'partialDamage':
                return '⸣';
            case 'superfluous':
                return '»';
            case 'omitted':
                return '›';
            case 'erasure':
                return '}';
            case 'isUninterpreted':
                return ':';
            case 'isWrittenOverErasure':
                return '*';
            case 'phoneticComplement':
                return ';';
            case 'isWrittenBelowTheLine':
                return '';
            case 'isWrittenAboveTheLine':
                return '';
            default:
                return '';
        }
    };
    TabletRenderer.prototype.applyBracketMarkup = function (markup, reading) {
        var formattedReading = this.addStartBracket(markup, reading);
        formattedReading = this.addEndBracket(markup, formattedReading);
        return formattedReading;
    };
    TabletRenderer.prototype.addStartBracket = function (markup, reading) {
        var bracket = this.getStartBracket(markup.type);
        var formattedReading = reading;
        if (markup.startChar === null) {
            if (this.shouldAddStartBracket(markup)) {
                formattedReading = bracket + formattedReading;
            }
        }
        else {
            var startChar = markup.startChar;
            var originalStartChar = startChar;
            var charCounter = 0;
            for (var i = 0; i < formattedReading.length; i += 1) {
                if (charCounter === originalStartChar) {
                    break;
                }
                else if (formattedReading[i].match(/([[\]{}⸢⸣«»‹›:;*?\\!])|(".+")|('.+')|(^\/)+/g)) {
                    startChar += 1;
                }
                else {
                    charCounter += 1;
                }
            }
            formattedReading =
                formattedReading.slice(0, startChar) +
                    bracket +
                    formattedReading.slice(startChar);
        }
        return formattedReading;
    };
    TabletRenderer.prototype.addEndBracket = function (markup, reading) {
        var bracket = this.getEndBracket(markup.type);
        var formattedReading = reading;
        if (markup.endChar === null) {
            if (this.shouldAddEndBracket(markup)) {
                formattedReading += bracket;
            }
        }
        else {
            var endChar = markup.endChar;
            var originalEndChar = endChar;
            var charCounter = 0;
            for (var i = 0; i < formattedReading.length; i += 1) {
                if (charCounter === originalEndChar) {
                    break;
                }
                else if (formattedReading[i].match(/([[\]{}⸢⸣«»‹›:;*?\\!])|(".+")|('.+')|(^\/)+/g)) {
                    endChar += 1;
                }
                else {
                    charCounter += 1;
                }
            }
            formattedReading =
                formattedReading.slice(0, endChar) +
                    bracket +
                    formattedReading.slice(endChar);
        }
        return formattedReading;
    };
    TabletRenderer.prototype.shouldAddStartBracket = function (markup) {
        return this.shouldAddBracket(markup, 'start');
    };
    TabletRenderer.prototype.shouldAddEndBracket = function (markup) {
        return this.shouldAddBracket(markup, 'end');
    };
    TabletRenderer.prototype.shouldAddBracket = function (markup, startOrEnd) {
        var unit = this.getEpigraphicUnitByUuid(markup.referenceUuid);
        if (!unit) {
            return false;
        }
        var _a = startOrEnd === 'start' ? [-1, 'endChar'] : [1, 'startChar'], tabletDiff = _a[0], neighborChar = _a[1];
        var neighbor = this.epigraphicUnits.find(function (item) {
            return unit.charOnTablet &&
                item.charOnTablet === unit.charOnTablet + tabletDiff;
        });
        if (!neighbor || !neighbor.markups) {
            return true;
        }
        if (neighbor.line !== unit.line) {
            return true;
        }
        if ((0, tabletUtils_1.unitMatchesDamageType)(neighbor, markup.type)) {
            var damageMarkup = (0, tabletUtils_1.getMarkupByDamageType)(neighbor.markups, markup.type);
            if (damageMarkup && damageMarkup[neighborChar] !== null) {
                return true;
            }
            return false;
        }
        return true;
    };
    TabletRenderer.prototype.getEpigraphicUnitByUuid = function (uuid) {
        return this.epigraphicUnits.find(function (unit) { return unit.uuid === uuid; });
    };
    TabletRenderer.prototype.getEpigraphicUnitsByLine = function (line) {
        return this.epigraphicUnits.filter(function (unit) { return unit.line === line; });
    };
    TabletRenderer.prototype.getTransliterationString = function () {
        var _this = this;
        var transliterationString = '';
        this.sides.forEach(function (side) {
            if (transliterationString === '') {
                transliterationString = "".concat(side.side, "\n");
            }
            else {
                transliterationString = "".concat(transliterationString, "\n").concat(side.side, "\n");
            }
            var columns = _this.columnsOnSide(side.side);
            columns.forEach(function (column) {
                if (columns.length > 1) {
                    transliterationString = "".concat(transliterationString, "col. ").concat((0, tabletUtils_1.romanNumeral)(column), "\n");
                }
                var lines = _this.linesInColumn(column, side.side);
                lines.forEach(function (line) {
                    var lineReading = _this.lineReading(line);
                    transliterationString = "".concat(transliterationString).concat(lineReading, "\n");
                });
            });
        });
        return (0, tabletUtils_1.localizeString)(transliterationString, this.locale);
    };
    return TabletRenderer;
}());
exports.default = TabletRenderer;
//# sourceMappingURL=TabletRenderer.js.map